import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import Select from "react-select";
import { IconEdit, IconFilter, IconPlus, IconTrash } from "@tabler/icons-react";
import {
  deletePayScales,
  getDepartments,
  getProfitCenter,
  insertPayscale,
  getPayScale,
  getCategorys,
  getWageTypes,
  getWages,
  getDesignation,
  GetDynamicOptions,
} from "../../services/dataService";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import FilterComponent from "../pages/FilterComponent";
import { getSecureItem } from "../../services/SecureStorage";
export default function PayScale() {
  const UID = getSecureItem("userId");

  const [addPayScaleModal, setAddPayScaleModal] = useState(false);
  const [editPayScaleModal, setEditPayScaleModal] = useState(false);
  const [payScales, setPayScales] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [profitCenters, setProfitCenters] = useState([]);
  const [department, setDepartment] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isloading, setisloading] = useState(false);
  const [filterText, setFilterText] = React.useState("");
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  const [deletePayScaleTypeId, setDeletePayScaleTypeId] = useState(null); // Correct naming convention
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categorys, setCategorys] = useState([]);
  const [salaryOptions, setSalaryOptions] = useState([]);
  const [WageType, setWageType] = useState([]);
  const [WageComponent, setWageComponent] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [payScaleData, setPayScaleData] = useState({
    Id: "",
    Name: "",
    Narration: "",
    UserId: "",
    CategoryId: "",
    SalaryGeneration: "",
    wageTypes: [], // Array of objects containing both WageTypeId and Amount
    IncrementAmount: [],
    WageComponentId: [],
    DesignationId: "",
  });

  useEffect(() => {
    const fetchDesignation = async () => {
      try {
        const response = await getDesignation(UID);
        setDesignation(response.data.data);
        console.log(designation, "pro");
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };
    fetchDesignation();
  }, []);

  // jjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjlkjlkjkljlkj

  const wageTypeOptions = WageType?.map((type) => ({
    value: type.Id,
    label: type.Name,
  }));

  const handleWageTypeChange = (selectedOptions) => {
    const selectedTypes = selectedOptions || [];
    // Create array of wage type objects, preserving existing amounts
    const newWageTypes = selectedTypes?.map((type) => {
      // Find existing entry to preserve amount if it exists
      const existingEntry = payScaleData.wageTypes?.find(
        (wt) => wt.WageTypeId === type.value
      );

      return {
        WageTypeId: type.value,
        Amount: existingEntry?.Amount || "",
      };
    });

    setPayScaleData((prev) => ({
      ...prev,
      wageTypes: newWageTypes,
    }));
  };
  const [selectedType, setSelectedType] = useState(null);
  const [currentAmount, setCurrentAmount] = useState("");
  const [salaryAmount, setSalaryAmount] = useState("");
  const [incrementAmount, setIncrementAmount] = useState("");

  const handleAdd = () => {
    if (selectedType && currentAmount) {
      const newWageType = {
        WageTypeId: selectedType.value,
        Amount: currentAmount,
      };

      // Check if wage type already exists
      const exists = payScaleData.wageTypes?.some(
        (wt) => wt.WageTypeId === selectedType.value
      );

      if (!exists) {
        setPayScaleData((prev) => ({
          ...prev,
          wageTypes: [...(prev.wageTypes || []), newWageType],
        }));

        // Reset inputs
        setSelectedType(null);
        setCurrentAmount("");
      }
    }
  };
  const handleAddincrement = (e) => {
    e.preventDefault();
    if (salaryAmount && incrementAmount) {
      const newIncrement = {
        id: Date.now(), // Adding an id for unique key in mapping
        SalaryAmount: salaryAmount,
        IncrementAmount: incrementAmount,
      };

      setPayScaleData((prev) => ({
        ...prev,
        IncrementAmount: [...(prev.IncrementAmount || []), newIncrement],
      }));

      // Reset inputs
      setSalaryAmount("");
      setIncrementAmount("");
    }
  };

  const handleDeleteincrement = (id) => {
    setPayScaleData((prev) => ({
      ...prev,
      IncrementAmount: prev.IncrementAmount.filter((item) => item.id !== id),
    }));
  };

  const handleDeletetype = (wageTypeId) => {
    setPayScaleData((prev) => ({
      ...prev,
      wageTypes: prev.wageTypes.filter((wt) => wt.WageTypeId !== wageTypeId),
    }));
  };

  // Filter out already selected wage types from options
  const availableOptions = wageTypeOptions.filter(
    (option) =>
      !payScaleData.wageTypes?.some((wt) => wt.WageTypeId === option.value)
  );
  const handleAmountChange = (wageTypeId, value) => {
    setPayScaleData((prev) => ({
      ...prev,
      wageTypes: prev.wageTypes?.map((wt) =>
        wt.WageTypeId === wageTypeId ? { ...wt, Amount: value } : wt
      ),
    }));
  };

  // Get currently selected options for the Select component
  const selectedOptions = wageTypeOptions?.filter((option) =>
    payScaleData?.wageTypes?.some((wt) => wt.WageTypeId === option.value)
  );

  const openAddPayScaleModal = () => {
    setPayScaleData({
      Id: "",
      Name: "",
      Narration: "",
      ProfitCenterId: "",
      UserId: UID,
      DepartmentId: "",
      CategoryId: "",
      SalaryGeneration: "",
    });
    setAddPayScaleModal(!addPayScaleModal);
  };

  const openEditPayScaleModal = (data) => {
    console.log("data", data);
    // profitcenter id name
    // const ProfitCenterName = profitCenters.find((item) => {
    //   console.log(profitCenters, "crProfit");

    //   if (item.Id == data?.ProfitCenterId) {
    //     return item?.Name;
    //   }
    // });
    // console.log("ProfitCenterName", ProfitCenterName);

    // departement ID
    // const DepartmentName = department.find((item) => {
    //   console.log(department, "department");

    //   if (item.Id == data?.DepartmentId) {
    //     return item?.Name;
    //   }
    // });
    // console.log("DepartmentName", DepartmentName);

    setEditPayScaleModal(!editPayScaleModal);
    console.log("data", data);

    setPayScaleData({
      ...data,
      ProfitCenterId: data?.ProfitCenterId,
      DepartmentId: data?.DepartmentId,
      // ProfitCenter: ProfitCenterName?.Name,
      // Department: DepartmentName?.Name,
      UserId: UID || "",
      CategoryId: data?.CategoryId,
      SalaryGeneration: data?.SalaryGeneration,
    });
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   try {
  //     const response = await insertPayscale(payScaleData);
  //     if (response.data.StatusCode === 200) {
  //       toast.success("Pay Scale added successfully");
  //       fetchPayScales();
  //       openAddPayScaleModal();
  //     }
  //   } catch (error) {
  //     const errorMessage =
  //       error.response?.data?.error ||
  //       error.message ||
  //       "An unexpected error occurred.";

  //     if (errorMessage.includes("Duplicate Name")) {
  //       toast.error("The code is already in use. Please use a unique code");
  //     } else {
  //       toast.error("Error occurred while adding Pay Scale.");
  //     }
  //     console.error("Error adding Pay Scale:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // edit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Construct the payload
      const payload = {
        ...payScaleData, // Spread the existing payScaleData
        wageTypes:
          payScaleData.wageTypes?.map((wt) => ({
            WageTypeId: wt.WageTypeId,
            Amount: wt.Amount,
          })) || [], // Ensure wageTypes is an array, even if empty
        IncrementAmount:
          payScaleData.IncrementAmount?.map((inc) => ({
            SalaryAmount: inc.SalaryAmount,
            IncrementAmount: inc.IncrementAmount,
          })) || [], // Ensure IncrementAmount is an array, even if empty
      };

      // Log the payload for debugging
      console.log("Payload being sent:", payload);

      // Send the payload to the backend
      const response = await insertPayscale(payload);

      if (response.data.StatusCode === 200) {
        toast.success(response.data.message); // Success message
        fetchPayScales(); // Refresh data
        openAddPayScaleModal(); // Close modal
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Invalid string")) {
        toast.error(
          "Invalid value for Wage Component. Please verify the input."
        );
      } else if (errorMessage.includes("Duplicate Name")) {
        toast.error("The code is already in use. Please use a unique code.");
      } else {
        toast.error("Error occurred while adding Pay Scale.");
      }
      console.error("Error adding Pay Scale:", error);
    } finally {
      setLoading(false);
    }
  };

  const [editingRowId, setEditingRowId] = useState(null);
  const handleEditRowClick = (id) => {
    setEditingRowId(id); // Set the row ID being edited
  };

  const handleIncrementChange = (id, field, value) => {
    setPayScaleData((prev) => ({
      ...prev,
      IncrementAmount: prev.IncrementAmount.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      ),
    }));
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        ...payScaleData,
        wageTypes: payScaleData.wageTypes.map((wt) => ({
          WageTypeId: wt.WageTypeId,
          Amount: wt.Amount,
        })),
        IncrementAmount: payScaleData.IncrementAmount.map((inc) => ({
          SalaryAmount: inc.SalaryAmount,
          IncrementAmount: inc.IncrementAmount,
        })),
      };

      const response = await insertPayscale(payload);

      if (response.data.StatusCode === 200) {
        toast.success(response.data.message);
        fetchPayScales();
        openEditPayScaleModal();
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Duplicate Name")) {
        toast.error("The code is already in use. Please use a unique code");
      } else {
        toast.error("Error occurred while editing Pay Scale.");
      }
      console.error("Error editing Pay Scale:", error);
    } finally {
      setLoading(false);
    }
  };

  // const handleEdit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   try {
  //     // Construct the payload
  //     const payload = {
  //       ...payScaleData,
  //       wageTypes: payScaleData.wageTypes.map(wt => ({
  //         WageTypeId: wt.WageTypeId,
  //         Amount: wt.Amount
  //       })),
  //       IncrementAmount: payScaleData.IncrementAmount.map(inc => ({
  //         SalaryAmount: inc.SalaryAmount,
  //         IncrementAmount: inc.IncrementAmount
  //       }))
  //     };

  //     // Send the payload to the backend
  //     const response = await insertPayscale(payload);

  //     if (response.data.StatusCode === 200) {
  //       toast.success(response.data.message);
  //       fetchPayScales();
  //       openEditPayScaleModal();
  //     }
  //   } catch (error) {
  //     const errorMessage =
  //       error.response?.data?.error ||
  //       error.message ||
  //       "An unexpected error occurred.";

  //     if (errorMessage.includes("Duplicate Name")) {
  //       toast.error("The code is already in use. Please use a unique code");
  //     } else {
  //       toast.error("Error occurred while editing Pay Scale.");
  //     }
  //     console.error("Error editing Pay Scale:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleDelete = async (payScaleId) => {
    const removeData = { Id: payScaleId, TableName: "PayScale" };
    try {
      const res = await deletePayScales(removeData, UID);
      console.log("res", res);

      if (res && res.data) {
        if (res.data.message === "Deleted Successfully") {
          toast.success("Pay Scale deleted successfully");
          fetchPayScales(); // Refresh the list
        } else {
          toast.error("Unexpected response from the server.");
        }
      } else {
        toast.error("Error deleting PayScale ");
      }
    } catch (error) {
      if (error.response && error.response.status === 409) {
        const errorMessage =
          error.response.data?.message ||
          "Conflict occurred while deleting PayScale .";
        toast.error("Pay Scale already using cannot delete");
      } else {
        console.error("Error removing PayScale:", error);
        toast.error("Error deleting Pay Scale . Please try again.");
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target || e; // Handle both standard and react-select events

    if (name === "WageComponentId") {
      setPayScaleData((prev) => ({
        ...prev,
        WageComponentId: value, // `value` is an array of selected IDs from react-select
      }));
      return;
    }

    if (name === "WageTypeId") {
      const wageType = WageType.find((el) => el.Id === value);
      if (wageType) {
        const amount = wageType.Amount;
        setPayScaleData((prev) => ({
          ...prev,
          Amount: parseInt(amount),
        }));
      }
    }

    // Generic state update
    setPayScaleData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fetchPayScales = async () => {
    try {
      const data = await getPayScale(UID);
      console.log(data.data.data, "Fetched fdsddata");
      setPayScales(data.data.data);
      setIsFilterVisible(false);
    } catch (error) {
      console.error("Error fetching payScales", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await GetDynamicOptions({
          optionType: "SalaryGenerationOption",
        });
        console.log("response option", response);

        setSalaryOptions(response.data.data); // Make sure response structure is correct
      } catch (error) {
        console.error("Error fetching salary options:", error);
      }
    };

    fetchOptions();
  }, []);

  const openModal = (payScaleId) => {
    setDeletePayScaleTypeId(payScaleId);
    setIsModalOpen(true);
  };

  // Close the modal and reset the state
  const closeModal = () => {
    setIsModalOpen(false);
    setDeletePayScaleTypeId(null);
  };

  // Trigger the delete operation and close the modal
  const confirmDelete = () => {
    if (deletePayScaleTypeId) {
      handleDelete(deletePayScaleTypeId); // Ensure handleDelete is defined correctly
    }
    closeModal();
  };

  const columnsFilter = [
    {
      name: "Sl No",
      selector: (row, index) => index + 1,
      sortable: true,
      grow: 0,
      width: "80px",
    },
    {
      name: " PayScale ",
      selector: (row) => row.Name,
      sortable: true,
    },
    // {
    //   name: "Category",
    //   selector: (row) => {
    //     const category = categorys.find((el) => el.Id === row.CategoryId);
    //     return category ? category.Name : 'N/A'; // Fallback in case category is not found
    //   },
    //   sortable: true,
    // },
    {
      name: "DesignationName",
      selector: (row) => row.DesignationName,
      sortable: true,
    },
    {
      name: " SalaryGeneration",
      selector: (row) => row.SalaryGeneration,
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => openEditPayScaleModal(row)}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            className="bg-danger rounded-[4px] px-10 py-[8px]"
            onClick={() => openModal(row.Id)}
          >
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>
        </div>
      ),
    },
  ];

  const filteredItems = dataFilter?.filter((item) => {
    return (
      item.Name?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.SalaryGeneration?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.DesignationName?.toLowerCase().includes(filterText.toLowerCase())
    );
  });

  const subHeaderComponentMemo = useMemo(() => {}, [
    filterText,
    resetPaginationToggle,
  ]);

  const clearData = () => {
    setPayScaleData({
      Id: "",
      Name: "",
      Narration: "",
      UserId: UID,
      CategoryId: "",
      WageComponentId: "",
      WageTypeId: "",
      Amount: "",
      IncrementAmount: "",
    });
  };

  const clearDataForEdit = () => {
    setPayScaleData((ref) => ({
      ...ref, // Spread the previous state
      Name: "",
      Narration: "",
      UserId: UID,
      CategoryId: "",
      WageComponentId: "",
      WageTypeId: "",
      Amount: "",
      IncrementAmount: "",
    }));
  };

  useEffect(() => {
    const fetchProfitCenters = async () => {
      try {
        const response = await getProfitCenter(UID);
        const responses = await getDepartments(UID);

        setDepartment(responses.data.data);
        console.log(department, "dept");

        setProfitCenters(response.data.data);
        console.log(profitCenters, "pro");
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };

    fetchProfitCenters();
  }, []);

  useEffect(() => {
    setLoading(true);
    fetchPayScales();
  }, []);

  useEffect(() => {
    console.log("paysacladataaa", payScaleData);
  }, [payScaleData]);

  useEffect(() => {
    const fetchCategorys = async () => {
      try {
        const response = await getCategorys(UID);

        setCategorys(response.data.data);
        console.log(categorys, "pro");
      } catch (error) {
        console.error("Error fetching Categorys:", error);
      }
    };

    fetchCategorys();
  }, []);

  useEffect(() => {
    const fetchCommonDatas = async () => {
      try {
        const response = await getWageTypes(UID);

        setWageType(response.data.data);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };

    fetchCommonDatas();
  }, []);
  useEffect(() => {
    const fetchCommonDatas = async () => {
      try {
        const response = await getWages(UID);

        setWageComponent(response.data.data);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };

    fetchCommonDatas();
  }, []);

  useEffect(() => {
    if (payScales && payScales.length > 0) {
      const updatedData = payScales?.map((item, index) => ({
        Slno: index + 1,
        Id: item.Id || "",
        Name: item.Name || "",
        Narration: item.Narration || "",
        Code: item.Code || "",
        ProfitCenterId: item.ProfitCenterId || "",
        UserId: item.UserId || "",
        DepartmentId: item.DepartmentId || "",
        CategoryId: item.CategoryId || "",
        WageTypeId: item.WageTypeId || "",
        Amount: item.Amount || "",
        WageComponentId: item?.WageComponentId
          ? JSON.parse(item?.WageComponentId)
          : [],
        IncrementAmount: item.IncrementAmount || "",
        SalaryGeneration: item.SalaryGeneration || "",
        wageTypes: item.wageTypes || [],
        DesignationId: item.DesignationId || "",
        DesignationName: item.DesignationName || "",
      }));
      setDataFilter(updatedData);
    } else {
      setDataFilter([]);
    }
  }, [payScales]);

  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults); // Update state with the filtered data
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this Pay Scale?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="flex items-center justify-between mb-8">
        <Breadcrumb title="PayScales" />

        {/* Action Area */}
        <div className="flex items-center gap-4">
          {/* Search and Clear Buttons */}
          <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
            <button
              className="bg-sky rounded-[4px] px-10 py-[8px]"
              onClick={handleFilterClick}
            >
              <IconFilter className="text-white w-[18px] h-[18px]" />
            </button>
            <div className="relative">
              <input
                type="text"
                id="search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                placeholder="Search by payscale/designation/Salary"
                className="w-64 px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button onClick={handleClear} className="btn btn-danger">
              Clear
            </button>
          </div>

          {/* Add New Button */}
          <button onClick={openAddPayScaleModal} className="btn btn-primary">
            Add New
          </button>
        </div>
      </div>

      {isFilterVisible && (
        <FilterComponent
          columns={columnsFilter}
          data={payScales}
          onFilter={handleFilter}
        />
      )}
      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">
        <div className="react-data-table">
          <div className="react-data-table">
            {loading ? (
              <Loading />
            ) : (
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems}
                pagination
                paginationResetDefaultPage={resetPaginationToggle}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            )}
          </div>
        </div>
      </div>

      {/* ========================================Add============================================ */}

      {addPayScaleModal && (
        <>
          <div className="fixed p-15 w-full max-w-[800px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Add Pay Scale
                <span className="absolute top-0 right-0">
                  <button
                    onClick={openAddPayScaleModal}
                    className="btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </span>
              </h5>

              <form onSubmit={handleSubmit}>
                <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-1 gap-10">
                    <div className="form-group flex gap-10">
                      <div className="form-group flex-1 flex-col gap-2">
                        <label>
                          PayScale <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          id="Name"
                          name="Name"
                          placeholder="Name"
                          value={payScaleData.Name}
                          onChange={handleChange}
                          required
                          onBlur={(e) => {
                            handleChange({
                              target: {
                                name: "Name",
                                value: e.target.value.trim(),
                              },
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="form-group flex flex-col gap-2">
                      <div className="form-group flex flex-col">
                        <label>Designation</label>
                        <select
                          name="DesignationId"
                          value={payScaleData.DesignationId || ""}
                          onChange={handleChange}
                        >
                          <option value="" disabled selected>
                            Select Designation
                          </option>
                          {designation?.map((center) => (
                            <option key={center.Id} value={center.Id}>
                              {center.Name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="flex gap-10">
                      <div className="form-group flex flex-col flex-1">
                        <label>Wage Component</label>
                        <Select
                          isMulti
                          name="WageComponentId"
                          options={WageComponent?.map((center) => ({
                            value: center.Id,
                            label: center.Name,
                          }))}
                          value={payScaleData?.WageComponentId?.map((id) => {
                            const selectedOption = WageComponent?.find(
                              (center) => center.Id === id
                            );
                            return selectedOption
                              ? { value: id, label: selectedOption.Name }
                              : null;
                          })}
                          onChange={(selectedOptions) =>
                            handleChange({
                              name: "WageComponentId",
                              value: selectedOptions?.map(
                                (option) => option.value
                              ),
                            })
                          }
                        />
                      </div>

                      <div className="form-group flex flex-col flex-1">
                        <label>
                          Salary Generation Option{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <select
                          name="SalaryGeneration"
                          value={payScaleData?.SalaryGeneration}
                          onChange={handleChange}
                          required
                          className="p-2 border rounded"
                        >
                          <option key="" value="" disable selected>
                            Choose one
                          </option>
                          {salaryOptions.length > 0 ? (
                            salaryOptions.map((option, index) => (
                              <option key={index} value={option.OptionName}>
                                {option.OptionName}
                              </option>
                            ))
                          ) : (
                            <option disabled>No options available</option>
                          )}
                        </select>
                      </div>
                    </div>
                    <div className="w-full">
                      <h2 className="text-lg font-medium border-b mb-4">
                        Wage Types
                      </h2>
                      <div className="space-y-4">
                        <div className="flex items-end gap-4">
                          <div className="flex-1">
                            <label className="block mb-2">
                              Wage Type <span className="text-red-500">*</span>
                            </label>
                            <Select
                              value={selectedType}
                              onChange={setSelectedType}
                              options={availableOptions}
                              className="w-full"
                              isClearable
                            />
                          </div>

                          <div className="flex-1">
                            <label className="block mb-2">
                              Amount <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="number"
                              value={currentAmount}
                              onChange={(e) => setCurrentAmount(e.target.value)}
                              className="w-full p-2 border rounded"
                              placeholder="Enter amount"
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>

                          <div>
                            <button
                              onClick={handleAdd}
                              disabled={!selectedType || !currentAmount}
                              className="btn btn-primary disabled:cursor-not-allowed h-[36px] col-span-2"
                            >
                              <b className="">Add</b>
                            </button>
                          </div>
                        </div>

                        {payScaleData.wageTypes?.length > 0 && (
                          <div className="mt-4">
                            <table className="w-full border-collapse ">
                              <thead className="bg-gray-50">
                                <tr>
                                  <th className="p-2 text-left border">
                                    Wage Type
                                  </th>
                                  <th className="p-2 text-left border">
                                    Amount
                                  </th>
                                  <th className="p-2 text-center border">
                                    Action
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {payScaleData?.wageTypes?.map((wageType) => {
                                  const typeInfo = wageTypeOptions?.find(
                                    (t) => t.value === wageType.WageTypeId
                                  );
                                  return (
                                    <tr key={wageType.WageTypeId}>
                                      <td className="p-2 border  w-[325px]">
                                        {typeInfo?.label}
                                      </td>
                                      <td className="p-2 border">
                                        {wageType.Amount}
                                      </td>
                                      <td className="p-2 border text-center w-[50px]">
                                        <button
                                          onClick={() =>
                                            handleDeletetype(
                                              wageType.WageTypeId
                                            )
                                          }
                                          className="text-red-500 hover:text-red-700"
                                        >
                                          Delete
                                        </button>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="w-full">
                      <h2 className="text-lg font-medium border-b mb-4">
                        Salary Increment{" "}
                      </h2>
                      <div className="space-y-4">
                        <div className="flex items-end gap-4">
                          <div className="flex-1">
                            <label className="block mb-2">
                              Salary Amount{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="number"
                              value={salaryAmount}
                              onChange={(e) => setSalaryAmount(e.target.value)}
                              className="w-full p-2 border rounded"
                              placeholder="Enter salary amount"
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>

                          <div className="flex-1">
                            <label className="block mb-2">
                              Increment Amount{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="number"
                              value={incrementAmount}
                              onChange={(e) =>
                                setIncrementAmount(e.target.value)
                              }
                              className="w-full p-2 border rounded"
                              placeholder="Enter increment amount"
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>

                          <button
                            onClick={handleAddincrement}
                            disabled={!salaryAmount || !incrementAmount}
                            className="btn btn-primary disabled:cursor-not-allowed h-[36px] col-span-2"
                          >
                            <b className="">Add</b>
                          </button>
                        </div>

                        {payScaleData.IncrementAmount?.length > 0 && (
                          <div className="mt-4">
                            <table className="w-full border-collapse">
                              <thead className="bg-gray-50">
                                <tr>
                                  <th className="p-2 text-left border">
                                    Salary Amount
                                  </th>
                                  <th className="p-2 text-left border">
                                    Increment Amount
                                  </th>
                                  <th className="p-2 text-center border w-[50px]">
                                    Action
                                  </th>
                                  <th className="p-2 text-center border w-[50px]">
                                    Edit
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {payScaleData.IncrementAmount.map((item) => (
                                  <tr key={item.id}>
                                    <td className="p-2 border w-[325px]">
                                      {editingRowId === item.id ? (
                                        <input
                                          type="number"
                                          value={item.SalaryAmount}
                                          onChange={(e) =>
                                            handleIncrementChange(
                                              item.id,
                                              "SalaryAmount",
                                              e.target.value
                                            )
                                          }
                                          className="w-full p-2 border rounded"
                                        />
                                      ) : (
                                        item.SalaryAmount
                                      )}
                                    </td>
                                    <td className="p-2 border">
                                      {editingRowId === item.id ? (
                                        <input
                                          type="number"
                                          value={item.IncrementAmount}
                                          onChange={(e) =>
                                            handleIncrementChange(
                                              item.id,
                                              "IncrementAmount",
                                              e.target.value
                                            )
                                          }
                                          className="w-full p-2 border rounded"
                                        />
                                      ) : (
                                        item.IncrementAmount
                                      )}
                                    </td>
                                    <td className="p-2 border text-center">
                                      <button
                                        onClick={() =>
                                          handleDeleteincrement(item.id)
                                        }
                                        className="text-red-500 hover:text-red-700"
                                      >
                                        <IconTrash/>
                                      </button>
                                    </td>
                                    <td className="p-3 border-b text-center">
                                      {editingRowId === item.id ? (
                                        <button
                                          type="button"
                                          onClick={() => setEditingRowId(null)} // Save and exit edit mode
                                          className="text-green-500 hover:text-green-700"
                                        >
                                          ✔️
                                        </button>
                                      ) : (
                                        <button
                                          type="button"
                                          onClick={() =>
                                            handleEditRowClick(item.id)
                                          }
                                          className=""
                                        >
                                          <IconEdit/>
                                        </button>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="form-group flex-1 flex-col gap-2">
                      <label>Remarks</label>
                      <input
                        type="text"
                        id="Narration"
                        name="Narration"
                        placeholder="Remarks"
                        value={payScaleData.Narration}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    // onClick={clearData}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    disabled={loading || editingRowId !== null}
                    className="btn btn-primary"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            // onClick={openAddPayScaleModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}

      {/* ======================================================edit======================================= */}
      {editPayScaleModal && (
        <>
          <div className="fixed p-15 w-full max-w-[800px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Edit Pay Scale
                <span className="absolute top-0 right-0">
                  <button
                    onClick={openEditPayScaleModal}
                    className="btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </span>
              </h5>
              <form onSubmit={handleEdit}>
                <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-1 gap-10">
                    <div className="form-group flex gap-10">
                      <div className="form-group flex-1 flex-col gap-2">
                        <label>
                          PayScale <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          id="Name"
                          name="Name"
                          placeholder="Name"
                          value={payScaleData.Name}
                          onChange={handleChange}
                          required
                          onBlur={(e) => {
                            handleChange({
                              target: {
                                name: "Name",
                                value: e.target.value.trim(),
                              },
                            });
                          }}
                        />
                      </div>
                    </div>
                    {/* <div className="form-group flex flex-col gap-2">
                      <label>
                        Code <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="Code"
                        name="Code"
                        placeholder="Code"
                        value={payScaleData.Code}
                        onChange={handleChange}
                        required
                      />
                    </div> */}
                    <div className="form-group flex flex-col gap-2">
                      <div className="form-group flex flex-col">
                        <label>Designation</label>
                        <select
                          name="DesignationId"
                          value={payScaleData.DesignationId || ""}
                          onChange={handleChange}
                        >
                          <option value="" disabled selected>
                            Select Designation
                          </option>
                          {designation?.map((center) => (
                            <option key={center.Id} value={center.Id}>
                              {center.Name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {/* <div className="form-group flex flex-col">
                      <label>
                        Category <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="CategoryId"
                        value={payScaleData.CategoryId || ""}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>
                          Select Category
                        </option>
                        {categorys.map((center) => (
                          <option key={center.Id} value={center.Id}>
                            {center.Name}
                          </option>
                        ))}
                      </select>
                    </div> */}
                    <div className="flex gap-10">
                      <div className="form-group flex flex-col flex-1">
                        <label>Wage Component</label>
                        <Select
                          isMulti
                          name="WageComponentId"
                          options={WageComponent?.map((center) => ({
                            value: center.Id,
                            label: center.Name,
                          }))}
                          value={
                            Array.isArray(payScaleData?.WageComponentId)
                              ? payScaleData.WageComponentId.map((id) => {
                                  const selectedOption = WageComponent?.find(
                                    (center) => center.Id === id
                                  );
                                  return selectedOption
                                    ? { value: id, label: selectedOption.Name }
                                    : null;
                                })
                              : []
                          }
                          onChange={(selectedOptions) =>
                            handleChange({
                              name: "WageComponentId",
                              value: selectedOptions?.map(
                                (option) => option.value
                              ),
                            })
                          }
                        />
                      </div>
                      <div className="form-group flex flex-col flex-1">
                        <label>
                          Salary Generation Option{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <select
                          name="SalaryGeneration"
                          value={payScaleData?.SalaryGeneration}
                          onChange={handleChange}
                          required
                          className="p-2 border rounded"
                        >
                          <option value="" key="" disabled selected>
                            Choose one
                          </option>
                          {salaryOptions.length > 0 ? (
                            salaryOptions.map((option, index) => (
                              <option key={index} value={option.OptionName}>
                                {option.OptionName}
                              </option>
                            ))
                          ) : (
                            <option disabled>No options available</option>
                          )}
                        </select>
                      </div>
                    </div>

                    <div className="w-full">
                      <h2 className="text-lg font-medium border-b mb-4">
                        Wage Types
                      </h2>
                      <div className="space-y-4">
                        <div className="flex items-end gap-4">
                          <div className="flex-1">
                            <label className="block mb-2">
                              Wage Type <span className="text-red-500">*</span>
                            </label>
                            <Select
                              value={selectedType}
                              onChange={setSelectedType}
                              options={availableOptions}
                              className="w-full"
                              isClearable
                            />
                          </div>

                          <div className="flex-1">
                            <label className="block mb-2">
                              Amount <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="number"
                              value={currentAmount}
                              onChange={(e) => setCurrentAmount(e.target.value)}
                              className="w-full p-2 border rounded"
                              placeholder="Enter amount"
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>

                          <div>
                            <button
                              onClick={handleAdd}
                              disabled={!selectedType || !currentAmount}
                              className="btn btn-primary disabled:cursor-not-allowed h-[36px] col-span-2"
                            >
                              <b className="">Add</b>
                            </button>
                          </div>
                        </div>

                        {payScaleData.wageTypes?.length > 0 && (
                          <div className="mt-4">
                            <table className="w-full border-collapse ">
                              <thead className="bg-gray-50">
                                <tr>
                                  <th className="p-2 text-left border">
                                    Wage Type
                                  </th>
                                  <th className="p-2 text-left border">
                                    Amount
                                  </th>
                                  <th className="p-2 text-center border">
                                    Action
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {payScaleData?.wageTypes?.map((wageType) => {
                                  const typeInfo = wageTypeOptions?.find(
                                    (t) => t.value === wageType.WageTypeId
                                  );
                                  return (
                                    <tr key={wageType.WageTypeId}>
                                      <td className="p-2 border  w-[325px]">
                                        {typeInfo?.label}
                                      </td>
                                      <td className="p-2 border">
                                        {wageType.Amount}
                                      </td>
                                      <td className="p-2 border text-center w-[50px]">
                                        <button
                                          onClick={() =>
                                            handleDeletetype(
                                              wageType.WageTypeId
                                            )
                                          }
                                          className="text-red-500 hover:text-red-700"
                                        >
                                          Delete
                                        </button>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="w-full">
                      <h2 className="text-lg font-medium border-b mb-4">
                        Salary Increment{" "}
                      </h2>
                      <div className="space-y-4">
                        <div className="flex items-end gap-4">
                          <div className="flex-1">
                            <label className="block mb-2">
                              Salary Amount{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="number"
                              value={salaryAmount}
                              onChange={(e) => setSalaryAmount(e.target.value)}
                              className="w-full p-2 border rounded"
                              placeholder="Enter salary amount"
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>

                          <div className="flex-1">
                            <label className="block mb-2">
                              Increment Amount{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="number"
                              value={incrementAmount}
                              onChange={(e) =>
                                setIncrementAmount(e.target.value)
                              }
                              className="w-full p-2 border rounded"
                              placeholder="Enter increment amount"
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>

                          <button
                            onClick={handleAddincrement}
                            disabled={!salaryAmount || !incrementAmount}
                            className="btn btn-primary disabled:cursor-not-allowed h-[36px] col-span-2"
                          >
                            <b className="">Add</b>
                          </button>
                        </div>

                        {payScaleData.IncrementAmount?.length > 0 && (
                          <div className="mt-4">
                            <table className="w-full border-collapse">
                              <thead className="bg-gray-50">
                                <tr>
                                  <th className="p-2 text-left border">
                                    Salary Amount
                                  </th>
                                  <th className="p-2 text-left border">
                                    Increment Amount
                                  </th>
                                  <th className="p-2 text-center border w-[50px]">
                                    Action
                                  </th>
                                  <th className="p-2 text-center border w-[50px]">
                                    Edit
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {payScaleData.IncrementAmount.map((item) => (
                                  <tr key={item.id}>
                                    <td className="p-2 border w-[325px]">
                                      {editingRowId === item.id ? (
                                        <input
                                          type="number"
                                          value={item.SalaryAmount}
                                          onChange={(e) =>
                                            handleIncrementChange(
                                              item.id,
                                              "SalaryAmount",
                                              e.target.value
                                            )
                                          }
                                          className="w-full p-2 border rounded"
                                        />
                                      ) : (
                                        item.SalaryAmount
                                      )}
                                    </td>
                                    <td className="p-2 border">
                                      {editingRowId === item.id ? (
                                        <input
                                          type="number"
                                          value={item.IncrementAmount}
                                          onChange={(e) =>
                                            handleIncrementChange(
                                              item.id,
                                              "IncrementAmount",
                                              e.target.value
                                            )
                                          }
                                          className="w-full p-2 border rounded"
                                        />
                                      ) : (
                                        item.IncrementAmount
                                      )}
                                    </td>
                                    <td className="p-2 border text-center">
                                      <button
                                        onClick={() =>
                                          handleDeleteincrement(item.id)
                                        }
                                        className="text-red-500 hover:text-red-700"
                                      >
                                        <IconTrash/>
                                      </button>
                                    </td>
                                    <td className="p-3 border-b text-center">
                                      {editingRowId === item.id ? (
                                        <button
                                          type="button"
                                          onClick={() => setEditingRowId(null)} // Save and exit edit mode
                                          className="text-green-500 hover:text-green-700"
                                        >
                                          ✔️
                                        </button>
                                      ) : (
                                        <button
                                          type="button"
                                          onClick={() =>
                                            handleEditRowClick(item.id)
                                          }
                                          className=""
                                        >
                                         <IconEdit/>
                                        </button>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="form-group flex-1 flex-col gap-2">
                      <label>Remarks</label>
                      <input
                        type="text"
                        id="Narration"
                        name="Narration"
                        placeholder="Remarks"
                        value={payScaleData.Narration}
                        onChange={handleChange}
                      />
                    </div>

                    {/* <div className="form-group flex flex-col">
                      <label>
                        Wage Component <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="WageComponentId"
                        value={payScaleData.WageComponentId || ""}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>
                          Select WageComponent
                        </option>
                        {WageComponent?.map((center) => (
                          <option key={center.Id} value={center.Id}>
                            {center.Name}
                          </option>
                        ))}
                      </select>
                    </div> */}

                    {/* <div className="form-group flex flex-col gap-2">
                      <label>
                        Increment Amount <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="IncrementAmount"
                        name="IncrementAmount"
                        placeholder="IncrementAmount"
                        value={payScaleData.IncrementAmount}
                        onChange={handleChange}
                        required
                        onWheel={(e) => e.target.blur()}
                      />
                    </div> */}

                    {/* <div className="form-group flex flex-col gap-2">
                      <label>
                        Salary Generation Option{" "}
                        <span style={{ color: "red" }}> *</span>
                      </label>
                      <select
                        name="SalaryGeneration"
                        value={payScaleData?.SalaryGeneration}
                        onChange={handleChange}
                        required
                      >
                        <option value="monthly">Monthly</option>
                        <option value="weekly">Weekly</option>
                      </select>
                    </div> */}
                  </div>
                </div>

                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    // onClick={clearDataForEdit}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading || editingRowId !== null}
                  >
                    {loading ? "Loading..." : "Update"}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            // onClick={openEditPayScaleModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
    </>
  );
}
